import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "@/data/site";

export default function TrainingBand() {
  return (
    <section className="relative overflow-hidden" style={{ backgroundColor: "#0d0d0d" }} aria-labelledby="training-band-heading">
      <div
        className="pointer-events-none absolute inset-0"
        style={{ background: "radial-gradient(52% 58% at 76% 40%, rgba(128,114,96,0.42) 0%, rgba(13,13,13,0) 68%)" }}
      />
      <div className="relative mx-auto grid max-w-7xl grid-cols-2 items-end">
        <div className="flex items-center py-6 pl-5 pr-3 sm:py-20 sm:pl-10 md:py-28 lg:pl-16">
          <div className="reveal max-w-xl">
            <p className="eyebrow text-[0.55rem] sm:text-xs">Lash Training</p>
            <h2
              id="training-band-heading"
              className="mt-2 font-display text-lg leading-[1.12] text-ivory sm:mt-4 sm:text-3xl md:text-4xl lg:text-5xl lg:leading-[1.08]"
            >
              Learn. Perfect. <span className="font-script text-gold">Elevate.</span>
            </h2>
            <p className="mt-3 text-[0.72rem] leading-relaxed text-muted-ivory sm:mt-6 sm:text-sm lg:text-base">
              Professional training for aspiring lash &amp; brow artists. Master your craft and build a
              successful beauty business with hands-on education from Golden Touch.
            </p>
            <Link
              to="/training"
              className="btn-gold-outline mt-5 inline-flex px-4 py-2.5 text-[0.55rem] tracking-[0.2em] uppercase sm:mt-9 sm:px-8 sm:py-3 sm:text-[0.72rem] sm:tracking-[0.25em]"
            >
              View Training
            </Link>
          </div>
        </div>
        <div className="flex items-end justify-center self-stretch sm:justify-end">
          <img
            src={IMAGES.training}
            alt="Golden Touch lash & brow educator"
            width={1122}
            height={1402}
            loading="lazy"
            decoding="async"
            className="block w-auto max-w-full object-contain object-bottom max-h-[280px] sm:max-h-[440px] lg:max-h-[560px]"
          />
        </div>
      </div>
    </section>
  );
}
